<template>
  <div>
    <section class="container-fluid">
      <h4 class="font-weight-bold text-left text-primary">Report Referral</h4>
      <br />
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <!-- <router-link :to="{name: 'createAboutus'}">
            <b-button variant="primary">
              <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
            </b-button>
          </router-link>-->
        </b-col>
      </b-row>
      <br />
      <div>
        <b-table
          striped
          hover
          :items="getReportRefferal"
          :per-page="perPage"
          :current-page="currentPage"
          :fields="fields"
          show-empty
          :filter="filter"
          :busy.sync="isBusy"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          @filtered="onFiltered"
          filter-debounce="500"
          head-variant="light"
          class="bg-white"
          empty-text="Data Empty"
        >
          <template v-slot:table-busy>
            <div class="text-center text-info my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template slot="empty" slot-scope="scope">
            <h4>{{ scope.emptyText }}</h4>
          </template>
          <!-- A virtual column -->
          <template slot="index" slot-scope="data">
            {{
            data.index + 1
            }}
          </template>
          <template v-slot:cell(actions)="{ value, item }">
            <b-link v-b-modal.modal-1 @click="detail(item.member_code)">
              <i class="far fa-eye"></i>
            </b-link>
          </template>
        </b-table>
        <br />
        <b-row class="mx-auto">
          <b-col md="4" align="left" class="mx-auto px-0">Total entries {{totalRows}}</b-col>
          <b-col md="4" class="mx-auto"></b-col>
          <b-col md="4" align="right" class="px-0">
            <b-pagination
              align="right"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
          </b-col>
        </b-row>
      </div>
    </section>
    <b-modal ok-only id="modal-1" size="lg" title="Detail Report Referral User">
      <b-table striped hover :fields="detail_field" show-empty :items="detail_data"></b-table>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      fields: [
        {
          key: 'member_code',
          label: 'Member Code',
        },
        {
          key: 'first_name',
          label: 'First Name',
        },
        {
          key: 'last_name',
          label: 'Last Name',
        },
        {
          key: 'username',
          label: 'Username',
        },
        {
          key: 'actions',
          label: 'Actions',
        },
      ],
      detail_field: [
        {
          key: 'member_code',
          label: 'Member Code',
        },
        {
          key: 'price',
          label: 'Price',
        },
        {
          key: 'remark',
          label: 'Referral From',
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      isBusy: false,
      sortDesc: false,
      sortDirection: 'asc',
      filter: '',
      detail_data: [],
    };
  },
  computed: {
    sortOptions() {
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
  },
  methods: {
    detail(id) {
      this.modalShow = !this.modalShow;
      this.$store
        .dispatch('ReportRefferalModule/getDetail', id)
        .then((response) => {
          this.detail_data = response;
        })
        .catch((error) => {
          this.$swal({
            type: 'error',
            title: 'Oops...',
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading = false;
        });
    },
    onFiltered(filteredItems) {
      setTimeout(() => {}, 2000);
    },
    getReportRefferal(ctx, callback) {
      this.isBusy = true;
      const vm = this;
      const formData = new FormData();
      formData.append('page', ctx.currentPage);
      formData.append('limit', ctx.perPage);
      formData.append('search_param', ctx.filter);
      this.$store
        .dispatch('ReportRefferalModule/getReportReferralPages', formData)
        .then((response) => {
          // let arr = response.data.data.map(data => {
          //   let article = JSON.parse(data.results);
          //   return {
          //     content: article.content.id,
          //     title: article.title.id,
          //     category: article.category
          //   };
          // });
          // vm.items = arr;
          vm.totalRows = response.data.data.total_record;
          callback(response.data.data.results || []);
          this.isBusy = false;
        })
        .catch((error) => {
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          // Returning an empty array, allows table to correctly handle
          // internal busy state in case of error
          this.isBusy = false;
          callback([]);
        });
      return null;
    },
  },
};
</script>
